import React from "react";

/**
 * Reusable form file input component
 * @param {Object} props
 * @param {string} props.id - Input id
 * @param {string} props.name - Input name
 * @param {string} props.label - Label text
 * @param {Function} props.onChange - Change handler
 * @param {string} props.accept - Accepted file types
 * @param {string} props.error - Error message
 * @param {boolean} props.required - Whether field is required
 * @param {string} props.maxSizeText - Text to display max size (e.g., "max 2 MB")
 * @param {Object} props.otherProps - Other input props
 */
const FormFileInput = ({
  id,
  name,
  label,
  onChange,
  accept,
  error,
  required = false,
  maxSizeText,
  value,
  ...otherProps
}) => {
  return (
    <div className="form-row">
      {label && (
        <label className="label-one" htmlFor={id}>
          {label}
          {maxSizeText && ` (${maxSizeText})`}
          {required && <span style={{ color: "#dc2626" }}> *</span>}
        </label>
      )}

      <label htmlFor={id} className={`upload-box ${error ? "has-error" : ""}`}>
        <input
          id={id}
          name={name}
          type="file"
          accept={accept}
          onChange={onChange}
          {...otherProps}
          className="file-input-hidden"
        />
        <div className="file-upload-placeholder">
          <span className="file-upload-icon">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 9.37549V14.3755C15 14.5413 14.9342 14.7002 14.8169 14.8174C14.6997 14.9346 14.5408 15.0005 14.375 15.0005H0.625C0.45924 15.0005 0.300269 14.9346 0.183058 14.8174C0.0658481 14.7002 0 14.5413 0 14.3755V9.37549C0 9.20973 0.0658481 9.05076 0.183058 8.93355C0.300269 8.81634 0.45924 8.75049 0.625 8.75049C0.79076 8.75049 0.949731 8.81634 1.06694 8.93355C1.18415 9.05076 1.25 9.20973 1.25 9.37549V13.7505H13.75V9.37549C13.75 9.20973 13.8158 9.05076 13.9331 8.93355C14.0503 8.81634 14.2092 8.75049 14.375 8.75049C14.5408 8.75049 14.6997 8.81634 14.8169 8.93355C14.9342 9.05076 15 9.20973 15 9.37549ZM4.81719 4.19268L6.875 2.13409V9.37549C6.875 9.54125 6.94085 9.70022 7.05806 9.81743C7.17527 9.93464 7.33424 10.0005 7.5 10.0005C7.66576 10.0005 7.82473 9.93464 7.94194 9.81743C8.05915 9.70022 8.125 9.54125 8.125 9.37549V2.13409L10.1828 4.19268C10.3001 4.30995 10.4591 4.37584 10.625 4.37584C10.7909 4.37584 10.9499 4.30995 11.0672 4.19268C11.1845 4.0754 11.2503 3.91634 11.2503 3.75049C11.2503 3.58464 11.1845 3.42558 11.0672 3.3083L7.94219 0.183304C7.88414 0.125194 7.81521 0.0790944 7.73934 0.0476417C7.66346 0.016189 7.58213 0 7.5 0C7.41787 0 7.33654 0.016189 7.26066 0.0476417C7.18479 0.0790944 7.11586 0.125194 7.05781 0.183304L3.93281 3.3083C3.81554 3.42558 3.74965 3.58464 3.74965 3.75049C3.74965 3.91634 3.81554 4.0754 3.93281 4.19268C4.05009 4.30995 4.20915 4.37584 4.375 4.37584C4.54085 4.37584 4.69991 4.30995 4.81719 4.19268Z"
                fill="#97262A"
              ></path>
            </svg>
          </span>
          <span className="file-upload-text">
            {value?.name || "Upload File"}
          </span>
        </div>
      </label>

      {error && <div className="error-text">{error}</div>}
    </div>
  );
};

export default FormFileInput;
